import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize, switchMap } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'wm-renewals-janus-application',
  standalone: false,
  templateUrl: './renewals-janus-application.component.html',
  styleUrls: ['./renewals-janus-application.component.scss']
})
export class RenewalsJanusApplicationComponent implements OnInit {

  private _row: any;
  private initializedForRow = false;
  private loadedChildApplicationId: string | null = null;

  @Input()
  set row(value: any) {
    this._row = value;
    this.tryInitialize();
  }
  get row(): any {
    return this._row;
  }

  isLoading = false;
  navigateToStepperForm = false;
  navigateToSummary = false;

  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.tryInitialize();
    this.route.queryParamMap.subscribe(params => {
      const childApplicationId =
        params.get('isChild') === '1' ? params.get('cid') : null;

      if (!childApplicationId) {
        this.loadedChildApplicationId = null;
        return;
      }

      if (childApplicationId === this.loadedChildApplicationId) {
        return;
      }

      this.loadedChildApplicationId = childApplicationId;
      this.prepareChildWorkflow(childApplicationId);
    });
  }

  private prepareChildWorkflow(applicationId: string): void {
    this.isLoading = true;
    this.navigateToStepperForm = false;

    this.dataService
      .isWorkflowApplicationInProgress(applicationId)
      .pipe(
        switchMap(() =>
          this.dataService.getCurrentApplicationActivity(applicationId)
        ),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: () => {
          this.navigateToStepperForm = true;
        },
        error: err => {
          console.error(err);
          this.navigateToStepperForm = true;
        }
      });
  }

  private tryInitialize(): void {
    if (this.initializedForRow || !this.row?.createdApplicationId) {
      return;
    }

    this.initializedForRow = true;

    // 🔥 Only Pending opens stepper
    if (this.isPendingApplication()) {
      this.loadApplication(this.row.createdApplicationId);
    } else {
      // All other statuses open summary
      this.navigateToSummary = true;
    }
  }

  private isPendingApplication(): boolean {

    // Adjust this based on your actual enum
    return (
      this.row?.status === 'Pending' ||
      this.row?.status === 1
    );
  }

  private loadApplication(applicationId: string): void {

    this.isLoading = true;

    this.dataService
      .isWorkflowApplicationInProgress(applicationId)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.loadCurrentActivity(applicationId);
        },
        error: err => console.error(err)
      });
  }

  private loadCurrentActivity(applicationId: string): void {

    this.dataService
      .getCurrentApplicationActivity(applicationId)
      .subscribe({
        next: (response: any) => {

          let activityDataId: string | undefined;

          if (response.activity?.activityDataId) {
            activityDataId = response.activity.activityDataId;
          }
          else {
            const formActivity = response.navigationActivities
              ?.find((a: any) => a.activityType === 'form-activity');

            if (!formActivity) {
              console.error('No form activity found');
              return;
            }

            activityDataId = formActivity.activityDataId;
          }

          if (!activityDataId) return;

          const currentPage = Number(this.route.snapshot.queryParamMap.get('p') ?? 0);
          this.router.navigate(
            [],
            {
              relativeTo: this.route,
              queryParams: {
                p: Number.isNaN(currentPage) ? 0 : currentPage,
                id: this.row.createdApplicationId,
                registrationId: this.row.id,
                activityDataId: activityDataId,
                workflowId: response.workflowId,
                workflowVersionId: response.workflowVersionId,
                isTest: response.isTestApplication,
                showAppView: 1
              },
              queryParamsHandling: 'merge'
            }
          );

          this.navigateToStepperForm = true;

        },
        error: err => console.error(err)
      });
  }
}
